(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kp-caliper-service"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root) => {
    if (root.dataset.kpInitialized === 'true') return;
    const form = root.querySelector('form');
    const select = root.querySelector('[data-kp-caliper-variant]');
    const submit = root.querySelector('[data-kp-caliper-submit]');
    const error = root.querySelector('[data-kp-caliper-error]');
    let data;
    try {
      data = JSON.parse(root.querySelector('[data-kp-caliper-data]').textContent);
      if (!Array.isArray(data.variants) || data.variants.length !== 128) return;
    } catch (_) { return; }
    const controls = [...root.querySelectorAll('[data-kp-caliper-flag]')];
    const state = () => Object.fromEntries(controls.map(input => [input.dataset.kpCaliperFlag, input.checked]));
    const masks = (value) => [
      Number(value.frontAdapter) + 2 * Number(value.rearAdapter),
      Number(value.frontLines) + 2 * Number(value.rearLines) + 4 * Number(value.fluid),
      Number(value.frontRebuild) + 2 * Number(value.rearRebuild)
    ];
    const variantFor = (mask) => data.variants.find(variant =>
      variant.options.every((value, index) => value === data.optionValues[index][mask[index]])
    );
    const empty = Object.fromEntries(controls.map(input => [input.dataset.kpCaliperFlag, false]));
    const base = variantFor([0, 0, 0]);
    if (!base) return;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency', currency: data.currency
    }).format(cents / 100);
    const restore = () => {
      const current = data.variants.find(v => String(v.id) === String(select.value)) || base;
      const indices = current.options.map((value, index) => data.optionValues[index].indexOf(value));
      const values = {
        frontAdapter: Boolean(indices[0] & 1), rearAdapter: Boolean(indices[0] & 2),
        frontLines: Boolean(indices[1] & 1), rearLines: Boolean(indices[1] & 2), fluid: Boolean(indices[1] & 4),
        frontRebuild: Boolean(indices[2] & 1), rearRebuild: Boolean(indices[2] & 2)
      };
      controls.forEach(input => { input.checked = values[input.dataset.kpCaliperFlag]; });
    };
    const update = () => {
      const selected = state();
      const variant = variantFor(masks(selected));
      error.hidden = Boolean(variant && variant.available);
      error.textContent = variant ? data.messages.unavailable : data.messages.error;
      submit.disabled = !variant || !variant.available;
      if (variant) {
        select.value = String(variant.id);
        root.querySelector('[data-kp-caliper-price]').textContent = money(variant.price);
      }
      const saving = root.querySelector('[data-kp-caliper-saving]');
      saving.hidden = !(selected.frontRebuild && selected.rearRebuild);
      if (!saving.hidden) {
        const both = variantFor([0,0,3]).price - base.price;
        const separate = variantFor([0,0,1]).price + variantFor([0,0,2]).price - 2 * base.price;
        saving.textContent = data.messages.bundle.replace('__TOTAL__', money(both)).replace('__SAVING__', money(separate - both));
      }
    };
    controls.forEach(input => {
      const key = input.dataset.kpCaliperFlag;
      const single = variantFor(masks({...empty, [key]: true}));
      const label = root.querySelector('[data-kp-caliper-adder="' + key + '"]');
      if (!single || !label) return;
      label.textContent = data.messages.plusPrice.replace('__PRICE__', money(single.price - base.price));
      input.addEventListener('change', update);
    });
    restore();
    update();
    root.querySelector('[data-kp-caliper-fallback]').hidden = true;
    root.querySelector('[data-kp-caliper-enhanced]').hidden = false;
    root.dataset.kpInitialized = 'true';
    form.addEventListener('submit', event => {
      update();
      if (submit.disabled) event.preventDefault();
    });
    window.addEventListener('pageshow', () => { restore(); update(); });
  };
  const initializeAll = () => document.querySelectorAll('[data-kp-caliper-config]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
  } catch(e) { console.error(e); }
})();

})();
